"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMapperCollectionHeader = exports.removeMapperCollectiono = exports.getStandaloneMapperCollections = exports.detachMapper = exports.createMapperCollection = exports.attachMapper = void 0;
var _store = require("../data/store");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getStandaloneMapperCollections = exports.getStandaloneMapperCollections = function getStandaloneMapperCollections() {
  return _toConsumableArray((0, _store.getStandaloneDataStore)().mapperCollections);
};
var createMapperCollection = exports.createMapperCollection = function createMapperCollection(creator) {
  var mapperCollections = getStandaloneMapperCollections();
  var data = _objectSpread(_objectSpread({}, creator), {}, {
    mappers: []
  });
  mapperCollections.push(data);
  (0, _store.updateStandaloneDataStore)({
    mapperCollections: mapperCollections
  });
  return data;
};
var updateMapperCollectionHeader = exports.updateMapperCollectionHeader = function updateMapperCollectionHeader(updateData) {
  var mapperCollections = getStandaloneMapperCollections();
  var foundIndex = mapperCollections.findIndex(function (item) {
    return item.id.value === updateData.id.value;
  });
  if (foundIndex >= 0) {
    var update = _objectSpread(_objectSpread({}, mapperCollections[foundIndex]), updateData);
    mapperCollections.splice(foundIndex, 1, update);
    (0, _store.updateStandaloneDataStore)({
      mapperCollections: mapperCollections
    });
    return update;
  }
  return null;
};
var removeMapperCollectiono = exports.removeMapperCollectiono = function removeMapperCollectiono(id) {
  var mapperCollections = getStandaloneMapperCollections();
  var foundIndex = mapperCollections.findIndex(function (item) {
    return item.id.value === id.value;
  });
  if (foundIndex >= 0) {
    var result = mapperCollections.splice(foundIndex, 1)[0];
    (0, _store.updateStandaloneDataStore)({
      mapperCollections: mapperCollections
    });
    return result;
  }
  return null;
};
var attachMapper = exports.attachMapper = function attachMapper(id) {
  var mapperCollections = getStandaloneMapperCollections();
  var foundIndex = mapperCollections.findIndex(function (item) {
    return item.id.value === id.collectionID.value;
  });
  if (foundIndex >= 0) {
    var foundMapperIndex = mapperCollections[foundIndex].mappers.findIndex(function (i) {
      return i.value === id.mapperID.value;
    });
    if (foundMapperIndex >= 0) {
      return mapperCollections[foundIndex];
    }
    var update = _objectSpread(_objectSpread({}, mapperCollections[foundIndex]), {}, {
      mappers: [].concat(_toConsumableArray(mapperCollections[foundIndex].mappers), [id.mapperID])
    });
    mapperCollections.splice(foundIndex, 1, update);
    (0, _store.updateStandaloneDataStore)({
      mapperCollections: mapperCollections
    });
    return update;
  }
  return null;
};
var detachMapper = exports.detachMapper = function detachMapper(id) {
  var mapperCollections = getStandaloneMapperCollections();
  var foundIndex = mapperCollections.findIndex(function (item) {
    return item.id.value === id.collectionID.value;
  });
  if (foundIndex >= 0) {
    var update = _objectSpread(_objectSpread({}, mapperCollections[foundIndex]), {}, {
      mappers: mapperCollections[foundIndex].mappers.filter(function (m) {
        return m.value !== id.mapperID.value;
      })
    });
    mapperCollections.splice(foundIndex, 1, update);
    (0, _store.updateStandaloneDataStore)({
      mapperCollections: mapperCollections
    });
    return update;
  }
  return null;
};